module.exports = __webpack_public_path__ + "img/two.e2df770f.jpg";